<template>
    <div class="MenuEditor">
		<card v-if="this.$GVO.my_profile.code == 11955 || this.$GVO.my_profile.code == 8136 || this.$GVO.my_profile.code == 8137 || this.$GVO.my_profile.code == 10420">
			<div class="">
				<h5><i class="tim-icons icon-send text-success mr-3"></i>Добавить запись о новой странице в таблицу menu</h5>
				
			</div>
			
			<div>
				<ReFormPrinter :masFormConfig="masAllFormParams" :objSaveApiMethod="currentApiFormMethod" :SuccessGo="SuccessGo" SuccessBtnText="Добавить меню" />
			</div> <!-- -->
		</card>
		<card
			v-loading.fullscreen.lock="$GVO.fullscreenLoading"
			element-loading-text="Загрузка данных..."
			element-loading-spinner="el-icon-loading"
			element-loading-background="rgba(0, 0, 0, 0.8)"	>
			<el-table :data="ApiData" style="width: 100%;">

			<el-table-column
				label="index"
				type="index"
				width="80"
			>
			</el-table-column>

			<el-table-column
				label="id"
				property="id"
				width="80"
			>
			</el-table-column>

			<el-table-column
				label="parentId"
				property="parentId"
				width="130"
			>
				<template v-slot="scope">		
					<base-input
						v-model="scope.row.parentId"
						autocomplete="off"
						type="number"
					>
					</base-input>
				</template>
			</el-table-column>

			<el-table-column 
				width="220"
				label="name"
				property="name"
			>
				<template v-slot="scope">		
					<base-input
						v-model="scope.row.name"
						autocomplete="off"
						type="text"
					>
					</base-input>
				</template>
			</el-table-column>
			<!-- <el-table-column 
				min-width="180"
				label="positiv_str_list"
				property="positiv_str_list"
			>
			</el-table-column>
			<el-table-column 
				min-width="180"
				label="negativ_str_list"
				property="negativ_str_list"
			>
			</el-table-column>
			<el-table-column 
				min-width="180"
				label="positiv_staff_list"
				property="positiv_staff_list"
			>
			</el-table-column>
			<el-table-column 
				min-width="180"
				label="negativ_staff_list"
				property="negativ_staff_list"
			>
			</el-table-column> -->
			<el-table-column 
				width="130"
				label="act"
				property="act"
				sortable
			>
				<template v-slot="scope">		
					<base-input
						v-model="scope.row.act"
						autocomplete="off"
						type="number"
					>
					</base-input>
				</template>
			</el-table-column>
		
			<el-table-column 
				width="130"
				label="sort"
				property="sort"
				sortable
			>
				<template v-slot="scope">		
					<base-input
						v-model="scope.row.sort"
						autocomplete="off"
						
					>
					</base-input>
				</template>
			</el-table-column>	
			
						
			<el-table-column
				label="path"
				property="path"
				min-width="200"
			>
				<template v-slot="scope">
					<base-input
						v-model="scope.row.path"
						autocomplete="off"
						type="text"
					>
					</base-input>
				</template>
			</el-table-column>

			<el-table-column
				label="icon"
				property="icon"
				min-width="200"
			>
				<template v-slot="scope">
					<base-input
						v-model="scope.row.icon"
						autocomplete="off"
						type="text"
					>
					</base-input>
				</template>
			</el-table-column>

			<el-table-column
				label="Обучающее видео"
				property="videoUrl"
				min-width="200"
			>
				<template v-slot="scope">
					<base-input
						v-model="scope.row.videoUrl"
						autocomplete="off"
						type="text"
					>
					</base-input>
				</template>
			</el-table-column>

			<el-table-column
				label="Роль"
				property="accRole"
				min-width="300"
			>
				<template v-slot="scope">
					<!-- <base-input
						v-model="scope.row.accRole"
						autocomplete="off"
						type="text"
						multiple
					>
					</base-input> -->


					<el-select
						class="overflow-overlay w-100 px-0 select-primary"
						v-model="scope.row.accRole" 
						placeholder="Роли"
						size="large"
						:multiple="true"								
					>
						<el-option
							class="select-primary"
							v-for="item in massAccRole.options"
							:key="item.value"
							:label="item.label"
							:value="item.value"
						>
						</el-option>
					</el-select>
				</template>
			</el-table-column>

			<el-table-column
					width="160"
					label="Действие"
				>
					<template v-slot="scope">			
						<el-button class="no-border my-0" >
							<button class="ml-3 btn btn-icon btn-simple btn-success" @click="UpdateMenu(scope.row)">
								<i class="tim-icons icon-book-bookmark"></i>
							</button>											
						</el-button>
					</template>
			</el-table-column>
			<!-- <el-table-column
				width="180"
				label="вкл\выкл act"
			>
				<template slot-scope="scope">		
					<ReActionBtns :masActions="masActions[scope.$index]"/>
					тут будут конпки ReActionBtns (вкл\выкл)
				</template>
			</el-table-column>			 -->
			</el-table>
			<Pagination class="mt-3" :class="[{'': parseInt(masObjects_total) > 0}, {'d-none': parseInt(masObjects_total) < 1}]"
				:type="'info'" 
				:total="parseInt(masObjects_total)*parseInt(count2page)" 
				:perPage="parseInt(count2page)"
				:value="parseInt(typeof objGetParams.p == 'undefined' ? 1:objGetParams.p)"
				:pClick="pClick">
			</Pagination>
		</card>
    
		</div>
</template>
<script>

// import {eventEmitter} from "src/plugins/globalComponents.js";
import { Table, TableColumn,  Select, Option, Tooltip, Button } from 'element-ui';
// import { BaseSwitch } from 'src/components/index';
import ReFormPrinter from "src/our_components/FormPrinter/ReFormPrinter.vue";
import Pagination from 'src/our_components/RePagination';
// import ReActionBtns from 'src/our_components/ReActionBtns.vue';

export default {
	name: 'menu_editor-page',
	components: {
	    [Table.name]: Table,
    	[TableColumn.name]: TableColumn,
        [Option.name]: Option,
        [Select.name]: Select,
        [Tooltip.name]: Tooltip,
        [Button.name]: Button,
		// BaseSwitch,
        ReFormPrinter,
        Pagination,
		// ReActionBtns,

	},
	data() {
		return {
			ApiData: [],
			masAllFormParams: this.currentFormConfig(),
			currentApiFormMethod: this.currentApiFormMethodComp(),
			objGetParams:{},
			masObjects_total: 0,
			count2page: 10,
			masActions:[],	
			fullscreenLoading: false,
			massAccRole: {
				options:[
					{value: '',label: 'Все сотрудники',},
					{value: 'CuratorEditor',label: 'Редактор кураторов застройщиков',},
					{value: 'CellEdditor',label: 'Редактор сот на карте',},
					{value: 'Support',label: 'Сотрудник сапорта системы',},
					{value: 'ObjModerator',label: 'Модератор объектов',},
					{value: 'PayMaster',label: 'Кассир',},
					{value: 'AdsMaster',label: 'Менеджер по рекламе',},
					{value: 'OperatorCC',label: 'Оператор Колл-центра',},
					{value: 'MasterCC',label: 'Руководитель Колл-центра',},
				]
			},
		};
	},
	methods: {
		getApiData(){
			this.$GVO.ApiCall('menu_adm.GET',{flt:{'list': true, 'c2p':100}} ) 
			.then((objApi) => {
				if(objApi.success === true){
					if(objApi.data.length > 0){
						this.ApiData = objApi.data;
						// console.log('objApi.data ', objApi.data.length); 
						this.masObjects_total = objApi.countpage;
						let saveToServName = '';

						// this.masActions = [];
						// for (let i = 0; i < this.ApiData.length; i++) {
						// 	this.masActions.push([
						// 		{
						// 			actionType: 'switcher',
						// 			label_on: 'Вкл',
						// 			label_off: 'Выкл',
						// 			action_model: this.ApiData[i].act=='1'?true:false,						
						// 			onClickApi: {apiMethod: 'CHANGE_CHECKLIST_ACT',apiParam:{obj:'BP_CHECKLIST',flt:{id:this.ApiData[i].id}}},
						// 		},
						// 		{
						// 			actionType: 'btn_del',
						// 			onClickApi: {apiMethod:'DEL',apiParam:{obj:'BP_CHECKLIST',flt:{id:this.ApiData[i].id}}},
						// 		},
						// 	]);							
						// }
					}else{
						this.ApiData = [];
						this.masObjects_total=0;
					}
				}else{
					this.ApiData = [];
					this.masObjects_total=0;
				}
			}).catch(errorObjApi => {this.ApiData = []; this.masObjects_total=0; console.error(errorObjApi);});
		},
		currentFormConfig() {
			this.$GVO.ApiCall('menu_adm.GET_FORM_MODEL',{})
				.then((objApi) => {
					if(objApi.success){
						this.masAllFormParams = objApi.config;
					}
				})
				.catch(errorObjApi => console.error(errorObjApi));
			return [];
		},
		currentApiFormMethodComp(){
            return {apiMethod:'menu_adm.INS',apiParam:{iData:[]}};
        },
		SuccessGo(evt,dopParam){
	        this.masAllFormParams = this.currentFormConfig();
			this.getApiData();
		},		

		// 	return saveToServName;
		// },
		// DeleteRow(row){
		// 	if(row.id != null){
		// 		this.$GVO.ApiCall('BP_CHECKLIST.DEL',{ flt:{id: row.id}}) 
		// 			.then((objApi) => {
		// 				if(objApi.success === true){
		// 					this.getApiData();
		// 				}else{
		// 					alert('Не удалилось');
		// 				}
		// 			}).catch(errorObjApi => {console.log(errorObjApi);});
		// 	}
		// },
		pClick(e){
			this.objGetParams['p'] = parseInt(e);
			// this.OnFilterApply();
		},
		// GoEdit(row){
		// 	if(row.id != null){
		// 		this.$router.push({path: this.$GVO.str_replace('/helpdesk','/helpdeskstaff',location.pathname)+'/'+row.id});
		// 	}
		// }
		// sortUp(row){
		// 	console.log('This is row id '+ row.id); 
		// },
		// sortDown(row){
		// 	console.log('This is row id '+ row.id); 
		// },
		UpdateMenu(row){
			// console.log('UpdateMenu. This is row id '+ row.id + ' and menu row name is ' + row.name); 

			if(row.id != null){
				this.$GVO.ApiCall('menu_adm.UPD',{ flt:{id: row.id},uData:{
					'parentId': row.parentId, 
					'path': row.path,
					'icon': row.icon, 
					'name': row.name,
					'positiv_str_list': '',
					'negativ_str_list': '',
					'positiv_staff_list': '',
					'negativ_staff_list': '',
					'act': row.act,
					'sort': row.sort,
					'accRole': row.accRole,
					'videoUrl': row.videoUrl,
					}}).then((objApi) => {
						//console.log(objApi);
						if(objApi.success === true){
							this.getApiData();
							this.openFullScreen1();
						}else{
							alert('Не сохранилось');
						}
					}).catch(errorObjApi => {console.error(errorObjApi);});
			}

			// if(this.$GVO.my_profile.code == 11955 || this.$GVO.my_profile.code == 8136 || this.$GVO.my_profile.code == 8137 || this.$GVO.my_profile.code == 10420){
				
			// } else {
			// 	// this.$GVO.showAlert('Доступ запрещён','<p>У Вас нет прав на создание и редактирование меню.</p>')
			// 	alert('У Вас нет прав на редактирование меню');
			// }
		}, 
		openFullScreen1(){
			this.fullscreenLoading = true;
			setTimeout(() => {
			this.fullscreenLoading = false;
			}, 10000);
		},
	},		
	mounted() {
		this.objGetParams = this.$GVO.GetAllGet();
		this.getApiData();
	}
};
</script>
<style>
.MenuEditor .bntGroup {
	display: flex;
	justify-content: flex-end;
}
.MenuEditor .form-options-group{
	flex-direction: row;
	width: 100%;
	align-items: center;
	flex-wrap: wrap;
}
.MenuEditor .form-options-group > div{
	margin-right: 5px;
}
.MenuEditor .form-group {
	margin-bottom: 0px!important;
}
.MenuEditor-table .cell, .Cellraspred-table button {
	word-break: break-word!important;
}
.MenuEditor .el-table tr:hover {
    background: rgb(1, 176, 224, 0.33);
}

</style>
